function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M15 3.42a5.512 5.512 0 01-1.65.478 3.016 3.016 0 001.263-1.677c-.555.348-1.17.6-1.824.736A2.801 2.801 0 0010.693 2C9.107 2 7.82 3.356 7.82 5.03c0 .237.026.468.075.69-2.387-.127-4.504-1.333-5.92-3.166a3.142 3.142 0 00-.39 1.523c0 1.051.508 1.979 1.279 2.522a2.75 2.75 0 01-1.301-.379v.038c0 1.468.99 2.692 2.303 2.97a2.736 2.736 0 01-1.297.053c.366 1.203 1.426 2.079 2.683 2.103A5.576 5.576 0 011 12.64 7.827 7.827 0 005.403 14c5.283 0 8.172-4.616 8.172-8.62 0-.13-.003-.261-.008-.391A6.022 6.022 0 0015 3.42z"
}));

var SvgIcTwitter = function SvgIcTwitter(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-twitter.eecbeb2d.svg";
export { SvgIcTwitter as ReactComponent };